import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    currentQuery: {
        path: null,
        products: [],
        lastEdge: null,
        lastScrollPos: 0,
        count: {
            fetched: 0,
            total: 0
        }
    }
};

const productQuerySlice = createSlice({
    name: "productQuery",
    initialState,
    reducers: {
        setProducts: (state, action) => {
            state.currentQuery = {
                path: action.payload.path,
                products: action.payload.products,
                lastEdge: action.payload.lastEdge,
                lastScrollPos: 0,
                count: {
                    fetched: action.payload.products.length,
                    total: 0
                }
            }
        },
        addProducts: (state, action) => {
            state.currentQuery.products = state.currentQuery.products.concat(action.payload.products);
            state.currentQuery.lastEdge = action.payload.lastEdge;
            state.currentQuery.count.fetched = state.currentQuery.products.length;
        },
        addProductsToList: (state, action) => {
            const firstLoadedProducts = state.currentQuery.products.slice(0, 6);
            state.currentQuery.products = firstLoadedProducts.concat(action.payload.products);
            state.currentQuery.count.fetched = action.payload.products.length + 6;
        },
        setProductCount: (state, action) => {
            if (action.payload.total === null) {
                state.currentQuery.count.total = 0;
            } else {
                state.currentQuery.count.total = action.payload.total;
            }
        },
        setLastScrollPos: (state, action) => {
            state.currentQuery.lastScrollPos = action.payload.scrollPos;
        }
    }
});

export const {
	setProducts,
	addProducts,
	setProductCount,
	setLastScrollPos,
	addProductsToList,
} = productQuerySlice.actions
export default productQuerySlice.reducer;